import { createRoutes } from 'shared/hocs'

import { TeamOverview } from './overview'
import { TeamView } from './view'

const Teams = createRoutes(({ match }) => [
  {
    path: `${match.path}/:teamId`,
    component: TeamView,
  },
  {
    exact: true,
    path: match.path,
    component: TeamOverview,
  },
])

export { Teams }
